module.exports = __webpack_public_path__ + "img/showcase-facebook-en-us.20cb8cdb.jpg";